import { Box, Flex } from "rebass";
import ChevronDown from "../../icons/ChevronDown";
import { Label } from "@rebass/forms";
import { getLocalizedText } from "../../utils/getLocalizedText";

const FilterItemMobile = ({
  name,
  label,
  options,
  values,
  open,
  onSelect,
  onToggleOpen,
  ...props
}) => {
  const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";
  const isOpen = open === name;

  return options?.length > 1 ? (
    <Box {...props}>
      <Flex
        alignItems="center"
        bg="#DEDEDE"
        height="40px"
        paddingX="10px"
        style={{
          gap: "22px",
          borderBottom: "3px solid #D2D2D2",
        }}
        justifyContent="space-between"
        onClick={() => onToggleOpen(name)}
      >
        <Label fontSize="12px">{label}</Label>
        <div>
          <ChevronDown
            style={{
              transform: isOpen ? "rotate(180deg)" : null,
              width: "20px",
              height: "20px",
            }}
          />
        </div>
      </Flex>
      {isOpen && (
        <Box sx={{ maxHeight: "250px", overflowY: "auto" }}>
          {options?.map((item, i) => (
            <Flex
              key={i}
              height="40px"
              bg="#f2f2f2"
              mb="2px"
              px="20px"
              alignItems="center"
              style={{ gap: "20px" }}
            >
              <input
                onChange={onSelect}
                type="checkbox"
                id={"category_" + item.id}
                data-value={item.id}
                className="p-2"
                style={{ width: "20px" }}
                checked={values?.includes(item.id)}
              />{" "}
              <Label fontSize="12px" color={item.disabled && "#888888"}>
                {getLocalizedText(item?.description)}
              </Label>
            </Flex>
          ))}
        </Box>
      )}
    </Box>
  ) : null;
};

export default FilterItemMobile;
